import { Stack } from '@zet/design-system/layout'
import { B1, H5 } from '@zet/design-system/typography'
import Lottie from 'lottie-react'

import { LoadingScreenProps } from '../../types'
import { Timer } from './timer'

export const Loader = ({
  title,
  description,
  timer,
  onTimerEnd = () => null,
}: LoadingScreenProps) => {
  return (
    <Stack className="mx-5 items-center">
      <Stack className="items-center">
        <Lottie
          autoPlay
          animationData={require('../../assets/lottie/Loading.json')}
          loop
        />
      </Stack>
      <Stack className="gap-y-4/2 items-center text-center">
        <H5 className="text-center">{title}</H5>
        <B1 className="text-grays-60 text-center">{description}</B1>
        {Boolean(timer?.enabled) && (
          <Timer
            durationInSeconds={timer?.durationInSeconds}
            onTimerEnd={onTimerEnd}
          />
        )}
      </Stack>
    </Stack>
  )
}
export default Loader
